import { css } from '@emotion/react';

export const IconBase = css`
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;
